import React from "react";
import Image from "next/image";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import slider1 from "@/Helper/images/slider/education/slider1.png";
const Education = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Improve learning experiences of students with AI
        </p>
        <p className="subheading">
          Visionfacts AI can identify areas of improvement within an educational
          institution. It can analyze student’s actions, offer better learning
          experience & ensure safety standards within the premises.
        </p>

        <div className="btn_container">
          <DemoButton PrimaryColorBtn />

          <Link href={"/education"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Digital signage software driving steadfast results"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Education;
